export default __webpack_public_path__ + "static/media/searchIcon.d1a6c25a.svg";